<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" (ngSubmit)="save(editForm.value)" [formGroup]="editForm">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'sections.new-section' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td>
              <h2>
                <span>{{ 'common.name' | translate }} *</span>
              </h2>
            </td>
            <td>
              <div class="ir-form-group margin">
                <validation-message
                  [validationControl]="editForm.controls.name"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  type="text"
                  formControlName="name"
                  rows="3"
                  placeholder="{{ 'sections.placeholders.section-name' | translate }}"
                  class="ir-form-set"
                />
              </div>
            </td>
          </tr>
        </table>
        <h2>
          <span>{{ 'common.description' | translate }}</span>
        </h2>
        <div class="ir-form-group">
          <textarea
            formControlName="description"
            rows="3"
            placeholder="{{ 'sections.placeholders.section-description' | translate }}"
            class="ir-form-set"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
